const LOGIN_URL = '/authorization/login/';

// Must be a real navigation, not a fetch: the PHP login page stores HTTP_REFERER in
// $_SESSION['referer'] (AuthorizationService::form) and returns the user there after login.
// Anything that strips the Referer (fetch, rel=noreferrer, a strict Referrer-Policy)
// silently breaks that return trip.
const redirectToLogin = () => {
	window.location.assign(LOGIN_URL);
};

let unauthorizedHandler = redirectToLogin;
let handling = false;

// Policy seam: swap the reaction to a 401 (SPA route, token refresh, …) without touching
// any of the API classes. Passing nothing restores the redirect.
export const setUnauthorizedHandler = handler => {
	unauthorizedHandler = typeof handler === 'function' ? handler : redirectToLogin;
};

// Re-arms the latch below. A policy that keeps the user on the page (e.g. refresh-and-retry)
// must call this, or the first 401 would be the last one ever handled.
export const resetUnauthorizedHandling = () => {
	handling = false;
};

// Latched: pages fire several requests at once, so N parallel 401s must produce ONE redirect.
export const handleUnauthorized = () => {
	if (handling) return;
	handling = true;

	unauthorizedHandler();
};

// Default target matches every other emitter of this URL (15 places, 2 Symfony + 13
// legacy) — kept as a literal fallback for the rare case a 409 body carries no
// `nextPath` at all, never as the primary source of truth.
const POSTREGISTRATION_URL = '/users/postregistration/';

let registrationIncompleteHandling = false;

const redirectToPostregistration = nextPath => {
	window.location.assign(nextPath || POSTREGISTRATION_URL);
};

let registrationIncompleteHandler = redirectToPostregistration;

/** Same policy-seam shape as `setUnauthorizedHandler` — swap the reaction without touching API classes. */
export const setRegistrationIncompleteHandler = handler => {
	registrationIncompleteHandler = typeof handler === 'function' ? handler : redirectToPostregistration;
};

export const resetRegistrationIncompleteHandling = () => {
	registrationIncompleteHandling = false;
};

/**
 * Reaction to the API gate's `409 registration_incomplete` (Phase D) — a real
 * navigation to `nextPath`, not a generic failure. Latched the same way as
 * `handleUnauthorized`: several requests can 409 in the same tick, and must
 * produce exactly one redirect.
 */
export const handleRegistrationIncomplete = nextPath => {
	if (registrationIncompleteHandling) return;
	registrationIncompleteHandling = true;

	registrationIncompleteHandler(nextPath);
};
